export const messages = {
  en: {
    shopProductType: {
      queryCondition: 'Query Condition',
      inputMenuName: 'Please input menu name',
      selectShowStatus: 'Please select show status',
      query: 'Query',
      mallMenu: 'Mall Menu',
      shopMenu: 'Shop Menu',
      goodsMenu: 'Goods Menu',
      servTypeMenu: 'Service Type Menu',
      servMenu: 'Service Menu',
      outsideMenu: 'Outside Menu',
      logo: 'Logo',
      menuName: 'Menu Name',
      menuDesc: 'Menu Description',
      label: 'Label',
      sort: 'Sort',
      isShow: 'Is Show',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      yes: 'Yes',
      no: 'No',
      skipType: 'Skip Type',
      all: 'All',
      phoneMenu: 'Phone Menu',
      shopTypeMenu: 'Shop Type Menu'
    },
    addAMenu: {
      add: 'Add',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      url: 'URL',
      inputUrl: 'Required, please input URL',
      urlTip: 'Input complete external address, need to include http or https.',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required'
    },
    addAShopMenu: {
      add: 'Add Shop Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      selectShop: 'Select Shop',
      inputShop: 'Please select shop',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      shopRequired: 'Shop is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    editMallMenu: {
      edit: 'Edit Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    addAGoodsMenu: {
      add: 'Add Goods Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      selectGoods: 'Select Goods',
      selectShop: 'Select Shop',
      inputShop: 'Please select shop',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      shopRequired: 'Shop is required',
      goodsRequired: 'Goods is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    addAServTypeMenu: {
      add: 'Add Service Type Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      servType: 'Service Type',
      selectServType: 'Please select service type',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      servTypeRequired: 'Service type is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    addAServMenu: {
      add: 'Add Service Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      selectServ: 'Select Service',
      selectShop: 'Select Shop',
      inputShop: 'Please select shop',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      shopRequired: 'Shop is required',
      servRequired: 'Service is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    addShopTypeMenu: {
      add: 'Add Shop Type Menu',
      menuName: 'Menu Name',
      inputMenuName: 'Required, please input menu name',
      logo: 'Logo',
      inputLogo: 'Required, please upload logo',
      menuDesc: 'Menu Description',
      inputMenuDesc: 'Optional, please input menu description',
      label: 'Label',
      inputLabel: 'Optional, please input label',
      shopType: 'Shop Type',
      selectShopType: 'Please select shop type',
      sort: 'Sort',
      inputSort: 'Required, please input sort number',
      isShow: 'Is Show',
      selectShowStatus: 'Required, please select show status',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name is required',
      logoRequired: 'Logo is required',
      shopTypeRequired: 'Shop type is required',
      sortRequired: 'Sort is required',
      showStatusRequired: 'Show status is required'
    },
    common: {
      saveSuccess: 'Save successfully'
    }
  },
  zh: {
    shopProductType: {
      queryCondition: '查询条件',
      inputMenuName: '请输入菜单名称',
      selectShowStatus: '请选择是否展示',
      query: '查询',
      mallMenu: '商圈菜单',
      shopMenu: '店铺菜单',
      goodsMenu: '商品菜单',
      servTypeMenu: '家政类型菜单',
      servMenu: '家政菜单',
      outsideMenu: '站外菜单',
      logo: 'logo',
      menuName: '菜单名称',
      menuDesc: '菜单描述',
      label: '标签',
      sort: '排序',
      isShow: '是否显示',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      skipType: '跳转类型',
      yes: '是',
      no: '否',
      all: '全部',
      phoneMenu: '手机菜单',
      shopTypeMenu: '店铺类型菜单'
    },
    addAMenu: {
      add: '添加',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: '小图标logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      url: 'URL',
      inputUrl: '必填，请填写URL',
      urlTip: '输入外部完整地址，需加上http或者https。',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空'
    },
    addAShopMenu: {
      add: '添加店铺菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      selectShop: '选择店铺',
      inputShop: '请选择店铺',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      shopRequired: '店铺不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    editMallMenu: {
      edit: '修改菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '是否显示',
      selectShowStatus: '必填，请选择是否显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    addAGoodsMenu: {
      add: '添加商品菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      selectGoods: '选择商品',
      selectShop: '选择店铺',
      inputShop: '请选择店铺',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      shopRequired: '店铺不能为空',
      goodsRequired: '商品不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    addAServTypeMenu: {
      add: '添加家政类型菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      servType: '家政类型',
      selectServType: '请选择家政类型',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      servTypeRequired: '家政类型不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    addAServMenu: {
      add: '添加家政菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      selectServ: '选择家政服务',
      selectShop: '选择店铺',
      inputShop: '请选择店铺',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      shopRequired: '店铺不能为空',
      servRequired: '家政服务不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    addShopTypeMenu: {
      add: '添加店铺类型菜单',
      menuName: '菜单名称',
      inputMenuName: '必填，请填写菜单名称',
      logo: 'logo',
      inputLogo: '必填，请上传logo',
      menuDesc: '菜单描述',
      inputMenuDesc: '选填，请填写服务描述',
      label: '标签',
      inputLabel: '选填，请填写标签',
      shopType: '店铺类型',
      selectShopType: '请选择店铺类型',
      sort: '排序',
      inputSort: '必填，请填写排序',
      isShow: '显示',
      selectShowStatus: '必填，请选择显示',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '类别名称不能为空',
      logoRequired: '小图标不能为空',
      shopTypeRequired: '店铺类型不能为空',
      sortRequired: '排序不能为空',
      showStatusRequired: '是否显示不能为空'
    },
    common: {
      saveSuccess: '保存成功'
    }
  }
}